

























import { OWebPageBase, OWebRouteContext } from "oweb";
import app from "@/app";
import { SXQuestion } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";

@Component
export default class PSurvey extends BaseComponent {
	loading = false;

	get surveyId() {
		return app.store.routeContext.getToken("id");
	}
	get survey() {
		return app.services.surveys.identify(this.surveyId);
	}
	get mainComponent() {
		return app.store.route!.slug;
	}
	get questions(): SXQuestion[] {
		if (this.survey) {
			return app.services.surveys.surveyQuestions(this.survey);
		}

		return [];
	}
	get customThemeData() {
		if (this.survey) {
			let company = app.services.companies.identify(
				this.survey.company_id
			);
			if (company) {
				let data = this.ux_custom_data(company.data);
				return {
					"--bg-color": data["bg_color"],
					"--txt-color": data["txt_color"]
				};
			}
		}
		return {};
	}
	get customUrl() {
		let x = this;
		return (
			this.survey &&
			app.services.urls.select(undefined, function(item) {
				return item.target === `sx_surveys_${x.survey!.id}`;
			})[0]
		);
	}

	created() {
		if (!this.survey || !this.questions.length || !this.customUrl) {
			let x = this,
				always = () => (x.loading = false);
			x.loading = true;
			app.services.surveys.get(
				this.surveyId,
				"questions|company|custom_url",
				function(response) {
					always();
					app.services.urls.addItemToList(
						response.data.relations!.custom_url
					);
				},
				always,
				false
			);
		}
	}
}
